
import { Component, ElementRef, EventEmitter, HostBinding, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { User } from '../data/user';
import { AuthService } from '../services/auth.service';


const sidebarBaseWidth = 50;
const generalDivBaseWidth = 50;

enum ROUTES {
  BOOK_LIST,
  CONFIG,
}

const routes = [
  {
    url: '/bookList',
    route: ROUTES.BOOK_LIST
  },
  {
    url: '/config',
    route: ROUTES.CONFIG
  },
  
];

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit, OnDestroy {
  @ViewChild('MainSidebar') root!: ElementRef<HTMLDivElement>;
  icons: HTMLImageElement[] = [];

  transition: number = 0.5;

  @HostBinding("attr.style")
  public get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(`--transition: ${this.transition}s`);
  }

  user: User | null = null;
  @Output() collapseEmitter = new EventEmitter<boolean>();
  collapsedSidenav = true;
  hidden = false;
  sidebarWidth = sidebarBaseWidth;
  generalDivWidth = generalDivBaseWidth;
  sidenavBackground = 'linear-gradient(180deg, #2C395B 0%, #1F2B42 100%)';
  showConfigurationMenu = false;
  showSearchMenu = true;
  showSubnav = false;

  showPacsMenu: boolean = false;

  currentUrl!: string;
  actualRoute!: string;
  actualIconRoute!: number;;

  ROUTES = ROUTES;

  isHover!: string;

  showFull = false;

  prpSlave:boolean = true;

  percentageInterval: NodeJS.Timeout | null = null;
  percentageUsed = -1;

  showConfigOption: boolean = false;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private configService: ConfigService,
    private authService: AuthService
  ) {
    this.loadUser();
  }

  private loadUser() {
    this.authService.asyncUser.then(user => {
      this.user = user;
      this.showConfigOption = !!user && (user.userName == 'Admin' || user.userName == 'admin');
    });
  }

  collapse() {
    this.collapsedSidenav = true;
    this.refreshNav();
  }

  expand() {
    this.collapsedSidenav = false;
    this.refreshNav();
  }

  ngOnDestroy(): void {
    if (this.percentageInterval != null)
      clearInterval(this.percentageInterval);
  }

  ngOnInit(): void {
    if (!this.actualIconRoute) {
      this.actualIconRoute = routes[0].route;
    }
    this.refreshIcons();

    
  }

  getRoute(url: string) {
    this.refreshIcons();
    return routes.find(r => url.startsWith(r.url));
  }

  changeRoute(route: string) {
    this.actualRoute = route;
    let r = this.getRoute(route);
    if (r) {
      this.actualIconRoute = r.route;
    }
    // Recargar el usuario cuando cambia la ruta
    this.loadUser();
    //this.authService.renewToken();
    this.refreshNav();
  }

  refreshIcons(currentURL: string | null = null) {
    if (this.hidden) {
      return;
    }
    const root = document.getElementById('mainSidebar');

    if (currentURL != null) {
      this.currentUrl = currentURL;
    }

    if (!root) {
      console.warn('El menú lateral no se ha cargado aún');
      // Si llega aquí, significa que debería ser visible pero no se ha cargado,
      // por lo que intentamos refrescarlos cada 100ms hasta que se cargue
      setTimeout(() => this.refreshIcons(currentURL), 100);
      return;
    }
  }

  hideNav(route: string | null = null) {
    this.hidden = true;
    const generalDiv = document.getElementById('general-div');
    if (generalDiv != null) {
      generalDiv.style.marginLeft = '0';
    }
    this.refreshIcons(route);
  }

  showNav(route: string | null = null) {
    this.hidden = false;
    // Recargar el usuario cuando se muestra el sidenav
    this.loadUser();
    const generalDiv = document.getElementById('general-div');
    if (this.collapsedSidenav) {
      if (generalDiv != null) {
        generalDiv.style.marginLeft = '55px';
      }
    }
    else {
      if (generalDiv != null) {
        generalDiv.style.marginLeft = '180px';
      }
    }
    this.refreshIcons(route);
    this.refreshNav();
  }

  refreshNav() {
    const root = document.getElementById('mainSidebar');
    if (!root) {
      setTimeout(() => this.refreshNav(), 100);
      return;
    }
    this.toggleSidebar();
  }

  toggleSidebar() {
    // this.refreshSubmenus();
    this.collapseEmitter.emit(this.collapsedSidenav);
    const sidebarElem = document.getElementById('mainSidebar');
    const generalDivElem = document.getElementById('general-div');

    this.sidebarWidth = sidebarBaseWidth;
    this.generalDivWidth = generalDivBaseWidth;

    if (!this.collapsedSidenav) {
      this.sidebarWidth += 125;
      this.generalDivWidth += 125;
      document.querySelectorAll('.icon-container').forEach(e => {
        e.classList.add('expanded');
      });
    } else {
      document.querySelectorAll('.icon-container').forEach(e => {
        e.classList.remove('expanded');
      });
    }

    if (sidebarElem) {
      sidebarElem.style.width = `${this.sidebarWidth}px`;
    }
    if (generalDivElem) {
      generalDivElem.style.marginLeft = `${this.generalDivWidth}px`;
    }
    this.refreshIcons();
  }

  toggleConfigurationMenu() {
    if (this.actualIconRoute && (this.actualIconRoute == ROUTES.CONFIG || this.actualIconRoute == ROUTES.BOOK_LIST)) {
      this.showConfigurationMenu = true;
    } else {
      this.showConfigurationMenu = !this.showConfigurationMenu;
    }
  }

  hideConfigurationMenu() {
    setTimeout(() => {
      if (this.actualIconRoute && (this.actualIconRoute == ROUTES.CONFIG || this.actualIconRoute == ROUTES.BOOK_LIST)) {
        this.showConfigurationMenu = true;
      } else {
        this.showConfigurationMenu = false;
      }
    }, 100);
  }

  /**
   * Funcion para que se muestren el menu de busqueda
   */
  toggleSearchMenu() {
    /*if (this.actualIconRoute ) {
      this.showSearchMenu = true;
    } else {
      this.showSearchMenu = !this.showSearchMenu;
    }*/
  }

  /**
   * Funcion para que se oculten el menu de busqueda
   */
  hideSearchMenu() {
    /*setTimeout(() => {
      if (this.actualIconRoute) {
        this.showSearchMenu = true;
      } else {
        this.showSearchMenu = false;
      }
    }, 100);*/
  }

  sendLogout() {
    this.authService.logout().then(res => {
      this.user = null; // Limpiar el usuario local
      this.router.navigate(['login']);
    }).catch(err => {
      // Aunque falle el logout en el servidor, limpiar localmente
      this.user = null;
      this.router.navigate(['login']);
    });
  }

  showConfigNotAvailable() {
    alert('Esta funcionalidad no está disponible');
  }

  getHeight(){
    if(this.prpSlave){
      return '29px'
    }else{
      return 'calc(29px * 3)'
    }
    
  }


  /**
   * Cambia la visibilidad del menu de Pacs
   */
  togglePacsMenu() {
  this.showPacsMenu = !this.showPacsMenu;
  }

  /**
   * Oculta el menu de Pacs
   */
  hidePacsMenu() {
    this.showPacsMenu = false;
  }


}
